import { combineReducers } from "redux";
import file from "./file";

const rootReducer = combineReducers({
  file
});

export default rootReducer;
